import { apiGet } from '../../fetch/apiService';

export function fetchDashboards() {
	return apiGet('dashboards');
}

